import React from 'react';

/**
 * Components
 */
import Button, { buttonType } from 'Components/Button';

export default ({ handleSignInClick, requestInProcess }) => {
  return (
    <form onSubmit={handleSignInClick}>
      <legend>Sign in</legend>
      <footer>
        <Button
          label='Sign in with NMMA Member Portal'
          formButtonType='submit'
          disabledWithSpinner={requestInProcess}
          buttonClassName='_height_40 _width_330 login-button'
          type={buttonType.primary}
        />
      </footer>
    </form>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/LoginScene/LoginPasswordInput.jsx